import {
	doReq
}
from 'voUtils/RestEx.js';

import {
	findResultFields
}
from 'voUtils/BrowserEx.js';
export default {
	data: {
		selectedImageIndex: undefined,
		openstreetmap: false,
		units: [],
		imagesForModal: []
	},
	beforeMount: function () {

		//	this.checkOsmConsent();


		let el = document.querySelector("[data-facility-id]");
		var facilityId;
		if (el) {
			facilityId = parseInt(el.getAttribute('data-facility-id'), 10);
		}
		var unitGroupId = this.getUnitgroupId(facilityId);
		var results = this.$el.getElementsByClassName('unit-list-section');
		if (results.length) {
			this.resultFields = findResultFields(results[0].innerHTML, this.$el);
		}


		var req = {
			fields: this.resultFields,
			filter: {
				unitgroupid: unitGroupId
			},
			sorting: 'random',
			max: 18
		};

		doReq('searchUnits', req)
			.then((res) => {
				this.units = res.units;
			});
	},

	mounted: function () {
		window.addEventListener('ccm19WidgetClosed', (event) => {
			this.checkOsmConsent();
		});
	},
	computed: {

		mailto: function () {
			return `mailto:${this.emailAddress}`;
		},
		emailAddress: function () {
			return (VOFFICE.contactEmail || ['website', 'v-office.com']).join('@');
		},
		phoneLink: function () {
			if (VOFFICE.phoneLink) {
				var el = document.getElementById('preloader');

				window.location.href = VOFFICE.phoneLink;
				if (el) {
					el.style.display = "none";
				}
			}
		},
		phoneView: function () {
			if (VOFFICE.phoneView) {
				return VOFFICE.phoneView;
			}
		}
	},
	methods: {
		getSearchUrl: function (facilityId) {
			return "s#?unitgroupid=" + this.getUnitgroupId(facilityId);
		},
		getUnitgroupId: function (facilityId) {
			var unitgroupid = '';
			if (facilityId == 172932) {
				unitgroupid = 74139; //Alpin & Seeresort
			} else if (facilityId == 172935) {
				unitgroupid = 74140; // Apartments Birke
			} else if (facilityId == 173032) {
				unitgroupid = 74141; // Apartments Bruckbergweg
			} else if (facilityId == 172934) {
				unitgroupid = 74142; // Chalet am Maiskogel
			} else if (facilityId == 172944) {
				unitgroupid = 74143; // Florianiweg
			} else if (facilityId == 191502) {
				unitgroupid = 74144; // Forststraße
			} else if (facilityId == 172943) {
				unitgroupid = 74145; // Gletscherblick
			} else if (facilityId == 172936) {
				unitgroupid = 74146; // Haus Kitzsteinhorn
			} else if (facilityId == 173030) {
				unitgroupid = 74147; // Lakeview Apartments
			} else if (facilityId == 172940) {
				unitgroupid = 74148; // Mozart Apartments
			} else if (facilityId == 172942) {
				unitgroupid = 74149; // Residenz Kaprun
			} else if (facilityId == 172933) {
				unitgroupid = 74150; // Select
			}
			return unitgroupid;
		},

		searchTab: function () {

			document.getElementById('obj-tab').classList.remove('active');
			document.getElementById('search-tab').classList.remove('active');
			document.getElementById('search-obj-form').style.display = 'none';
			document.getElementById('search-form').style.display = 'flex';
			document.getElementById('search-tab').classList.add('active');

		},
		objectTab: function () {

			document.getElementById('obj-tab').classList.remove('active');
			document.getElementById('search-tab').classList.remove('active');
			document.getElementById('search-form').style.display = 'none';
			document.getElementById('search-obj-form').style.display = 'flex';
			document.getElementById('obj-tab').classList.add('active');

		},

		checkOsmConsent: function () {
			const suffix = VOFFICE.token.substr(VOFFICE.token.length - 12);
			var cookieName = 'allowOpenstreetmap_' + suffix;
			const allowOpenstreet = this.getCookie(cookieName);
			if (allowOpenstreet) {
				this.openstreetmap = true;
			} else {
				const data = CCM.acceptedEmbeddings;
				const targetName = "OpenStreetMap";
				const entry = data.find(item => item.name === targetName);

				if (entry) {
					this.openstreetmap = true;
				} else {
					this.openstreetmap = false;
				}
			}
		},

		getCookie: function (name) {
			const nameEQ = name + "=";
			const ca = document.cookie.split(';');
			for (let i = 0; i < ca.length; i++) {
				let c = ca[i];
				while (c.charAt(0) === ' ') c = c.substring(1, c.length);
				if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
			}
			return null;
		},

		setCookie: function (name, value, days) {
			const date = new Date();
			date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
			const expires = "expires=" + date.toUTCString();
			document.cookie = name + "=" + value + ";" + expires + ";path=/";
		},

		allowOpenstreetmap: function () {
			const suffix = VOFFICE.token.substr(VOFFICE.token.length - 12);
			var cookieName = 'allowOpenstreetmap_' + suffix;
			this.setCookie(cookieName, true, VOFFICE.settings.osmCookieDays);
			this.openstreetmap = true;
		},

		showOpenstreetmap: function () {
			this.openstreetmap = true;
		},

		getUnitSearchTarget: function (id) {
			return 'unit_' + id;
		},

		unitImages: function (string) {
			//console.log(string);
		}


	},

};